import taxpayer_http from '@/js/http/taxpayer.js';

let axios = taxpayer_http().axios();

const state = {
    documents: [],
    currentDocument: null,
};

const getters = {
    getAllDocuments: (state) => state.documents,
    getCurrentDocument: (state) => state.currentDocument,
};

const mutations = {
    SET_DOCUMENTS(state, documents) {
        state.documents = documents;
    },
    SET_CURRENT_DOCUMENT(state, document) {
        state.currentDocument = document;
    },
    ADD_DOCUMENT(state, document) {
        state.documents.push(document);
    },
    UPDATE_DOCUMENT(state, updatedDocument) {
        const index = state.documents.findIndex(doc => doc.id === updatedDocument.id);
        if (index !== -1) {
            state.documents.splice(index, 1, updatedDocument);
        }
    },
};

const actions = {
    async fetchAll({ commit }, params) {
        try {
            let response = await axios.get('/taxpayer/documents', { params });
            commit('SET_DOCUMENTS', response.data.data);
            return response.data;
        } catch (error) {
            console.error('Error fetching documents:', error);
            throw error;
        }
    },

    async fetchById({ commit }, id) {
        try {
            let response = await axios.get(`/taxpayer/documents/${id}`);
            commit('SET_CURRENT_DOCUMENT', response.data);
            return response.data;
        } catch (error) {
            console.error('Error fetching document:', error);
            throw error;
        }
    },

    async create({ commit }, documentData) {
        try {
            let response = await axios.post('/taxpayer/documents', documentData);
            commit('ADD_DOCUMENT', response.data);
            return response.data;
        } catch (error) {
            console.error('Error creating document:', error);
            throw error;
        }
    },

    async update({ commit }, { id, data }) {
        try {
            let response = await axios.put(`/taxpayer/documents/${id}`, data);
            commit('UPDATE_DOCUMENT', response.data);
            return response.data;
        } catch (error) {
            console.error('Error updating document:', error);
            throw error;
        }
    },

    async delete({ commit }, id) {
        try {
            await axios.delete(`/taxpayer/documents/${id}`);
            // Optionally remove the document from the state here
        } catch (error) {
            console.error('Error deleting document:', error);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
